import styles from './style.module.css';
import Modal from 'react-responsive-modal';
import alert from '../../../../assets/images/alert.png';

interface IModalNoMoreAttempts {
  modalIsOpen: boolean;
  toggleModal: () => void;
}

export function ModalNoMoreAttempts({
  modalIsOpen,
  toggleModal,
}: IModalNoMoreAttempts) {
  return (
    <Modal
      open={modalIsOpen}
      onClose={() => {
        toggleModal();
      }}
      center
    >
      <div className={styles.contents}>
        <div className="d-flex justify-content-center">
          <img className={styles.alert} src={alert} alt="" />
        </div>
        <h1 className={styles.title}>
          <b className={styles.highlightText}>QUE PENA!</b> Suas tentativas
          acabaram e você não pontuou desta vez. Não desista: continue se
          engajando nos conteúdos!
        </h1>
      </div>
      <div className={styles.contentBtn}>
        <button
          onClick={() => {
            toggleModal();
          }}
          className={styles.btnAgree}
          type="button"
        >
          OK
        </button>
      </div>
    </Modal>
  );
}
